<script lang="ts" setup>
import PackingSlipForm from "@/data-views/forms/packing_slip/Form.vue";
definePage({
  meta: {
    action: "read",
    subject: "PackingSlip",
  },
});
</script>

<template>
  <div>
    <PackingSlipForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
